<template>
    <div class="logincss">

        <div style="height: 15%;width: 100%;background-color: white;">
            <img src="../../assets/img/logo3.png" style="height: 66px;margin-left: 35px;float: left;margin-top: 20px;">
            <div style="font-weight: bold;font-size: 30px;color: #78848b;margin-left: 10px;float: left;margin-top: 45px;font-family: 华文楷体">
               FSWAN会计财务软件
            </div>
            <div style="float: right;margin-right: 100px;padding-top: 30px">
                <svg t="1684980502507" style="margin-right: 10px" class="icon" viewBox="0 0 1036 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3260" width="30" height="30"><path d="M908.168081 854.420373c-2.781069-13.146874-5.688551-27.55787-11.756339-39.693445a313.034646 313.034646 0 0 0-79.89254-100.876973c-11.25069-9.354506-23.259853-17.950539-35.774666-25.661686-25.788098-15.801531-56.379862-19.593898-86.213152-20.352371-7.079086-0.126412-13.778935 2.27542-19.72031 6.067787-6.320612 4.045192-11.882751 9.228094-17.065653 14.790233-3.792367 4.045192-6.826261 8.596033-10.618629 12.641225-4.171604 4.424429-8.469621 8.596033-12.767637 12.767637-6.699849 6.447025-13.52611 12.641225-20.605196 18.709012-2.654657 2.27542-5.05649 5.182902-8.090384 6.952674-4.930078 2.781069-13.020461 1.011298-18.329776 0.379237a97.33743 97.33743 0 0 1-18.709012-4.171605c-10.745041-3.539543-19.973135-9.228094-29.454053-15.295881-22.880617-14.410996-46.266882-27.431457-67.124903-44.876348a914.845427 914.845427 0 0 1-65.102307-60.172229c-9.607331-9.733743-18.835425-19.593898-27.937107-29.83329a974.512007 974.512007 0 0 1-42.727339-51.19696c-13.273286-17.192066-25.788098-35.142604-36.533139-54.104441-5.309314-9.228094-10.745041-18.329776-14.663821-28.316344-3.539543-9.101682-6.573437-18.456188-3.286718-28.063518 1.896184-5.688551 5.182902-10.745041 8.722445-15.675119 13.020461-17.824127 29.074817-34.004894 46.266882-47.783829 14.790233-11.882751 19.593898-30.212527 16.180768-48.289478-1.769771-10.239392-3.413131-20.478784-6.320613-30.338939-11.124278-38.176498-33.372833-71.928568-59.919404-101.129797-12.135576-13.52611-24.523976-30.338939-40.325507-39.819858-19.341074-11.756339-39.440621-20.352372-61.562764-25.282449-21.742906-5.182902-44.749935 0.632061-64.975895 9.354506-38.682147 16.560004-71.296507 45.508409-94.809184 80.398189C14.433499 221.221431 6.722352 238.792733 2.550748 257.248921c-4.298016 19.593898-2.401833 38.176498 0.126412 57.770397 4.424429 33.246421 11.882751 66.113605 21.995731 98.095903 5.814963 18.329776 13.020461 36.406727 20.605196 54.104442 10.871453 25.029625 23.386266 48.921539 37.544437 72.307805 11.124278 18.329776 21.742906 37.291613 34.384131 54.61009 16.180768 22.122143 32.993596 43.738637 49.300776 65.734368 17.571302 23.512678 38.682147 44.244286 58.781695 65.607956 16.433592 17.571302 32.993596 35.142604 49.300776 52.966731 13.146874 14.537408 28.948404 26.293747 43.612225 39.187797 50.312074 44.244286 102.014683 87.477274 160.164316 121.102932 3.792367 2.149008 7.458323 4.298016 11.25069 6.447024 0.758473 0.505649 1.516947 0.884886 2.27542 1.264123l0.505649 0.252824c2.528245 1.516947 5.182902 2.907482 7.711147 4.424429a554.3177 554.3177 0 0 0 49.806425 25.029625c2.907482 1.264122 5.941376 2.654657 8.848858 3.918779 15.927943 6.826261 31.982298 12.894049 48.41589 18.709013 8.216796 2.907482 16.054355 6.320612 24.523976 8.596032 30.086115 8.216796 61.562764 14.410996 92.660176 16.30718 17.44489 1.011298 35.142604-0.379237 52.081846-4.803665 22.374968-6.067788 41.589629-17.571302 58.023221-33.75207 6.952674-6.826261 13.52611-14.158172 19.973135-21.237257 21.110845-23.133441 43.738637-46.266882 53.725205-76.858646 1.13771-3.792367 1.769771-7.711147 1.769771-11.629927 0.632061-7.205498-0.252824-14.158172-1.769771-20.984433zM1036.602923 536.999223h-63.206123C973.3968 275.705109 760.897814 63.206123 499.6037 63.206123V0C795.661181 0 1036.602923 240.941742 1036.602923 536.999223z" fill="#00AEE3" p-id="3261"></path><path d="M910.190677 536.999223h-63.206124C846.984553 345.484669 691.118254 189.61837 499.6037 189.61837v-63.206124C726.008034 126.412246 910.190677 310.594889 910.190677 536.999223z" fill="#00AEE3" p-id="3262"></path><path d="M783.77843 536.999223h-63.206123C720.572307 415.137817 621.465106 316.030616 499.6037 316.030616v-63.206123C656.354886 252.824493 783.77843 380.248037 783.77843 536.999223z" fill="#00AEE3" p-id="3263"></path></svg>
                <span style="font-size: 20px">服务热线：18976205160（微信同号）</span>
            </div>
        </div>

        <div class="mcss">
            <div style="margin: 20px;background-color: white;">
                <div class="loginbody">
                    <el-form v-model="ruleForm" status-icon :rules="rules" style="background-color: #8a979e;padding: 30px 20px">
                        <!-- 用户名 -->
                        <el-row>
                            <el-col :span="24" style="height: 36px;text-align: left;margin-bottom: 20px;">
                                <el-form-item>
                                    <el-input v-model="ruleForm.username" prefix-icon="el-icon-user" placeholder="用户名"
                                              autocomplete="off"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <!-- 密码 -->
                        <el-row>
                            <el-col :span="24" style="height: 36px;text-align: left;margin-bottom: 20px;">
                                <el-form-item label="">
                                    <el-input type="password" v-model="ruleForm.password" prefix-icon="el-icon-lock"
                                              placeholder="密码"
                                              autocomplete="off"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <!-- 输入验证码 -->
                        <el-row>
                            <el-col :span="12" style="height: 36px;text-align: left;margin-bottom: 20px;">
                                <el-form-item>
                                    <el-input
                                            placeholder="请输入验证码"
                                            v-model="ruleForm.code"
                                            clearable>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" style="height: 40px;text-align: left;margin-bottom: 20px;">
                                <el-form-item>
                                    <a @click="reImg()" style="cursor: pointer;">
                                        <img id="img" ref="codeImg"
                                             style="width: 117px; height: 38px;margin-left: 15px;border-radius: 5px;"
                                             src=""></a>
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <!-- 登录按钮 -->
                        <el-row>
                            <el-col :span="24" style="height: 36px;text-align: left;margin-bottom: 20px;">
                                <el-form-item>
                                    <el-button type="primary" style="width: 100%;border-radius: 5px;"
                                               @click.enter="submitForm()">登&nbsp;录
                                    </el-button>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
            </div>
        </div>

        <div style="height: 10%;width: 100%;background-color: white;text-align: center;margin-top: 25px">
            <div>
                关于我们 | 产品与服务 | 常见问题 | 团队支持 | 联系我们
            </div>
            <div style="margin-top: 20px">
                Copyright © 2018-2028 <a href="https://www.fswan.cn/" target="_blank">潮合（海南）科技有限公司</a> 备案号：<a href="https://beian.miit.gov.cn/" target="_blank">琼ICP备2021001740号-2</a>
            </div>
        </div>

    </div>
</template>

<script>

    export default {
        name: 'login',
        data() { // 页面的初始数据
            return {
                token: '',
                ruleForm: { // 存储用户输入数据
                    username: '',
                    password: '',
                    code: ''
                },
                rules: { // 可添加一些表单规则
                }
            }
        },
        methods: {
            reImg() {
                this.$httpTAG({
                    url: this.$httpTAG.adornUrl('/business/login/getCode'),
                    method: 'get',
                    responseType: 'blob'
                }).then(res => {
                    let img = this.$refs.codeImg;
                    let url = window.URL.createObjectURL(res.data);
                    img.src = url;
                    this.token = res.headers['access-token'];
                }).finally(r => {
                })
            },
            getDefaultLoginUser() {
                this.$httpTAG({
                    url: this.$httpTAG.adornUrl('/business/login/getDefaultLoginUser'),
                    method: 'get',
                    responseType: 'json'
                }).then(res => {
                    this.ruleForm = res.data;
                }).finally(r => {
                })
            },
            submitForm() {

                this.$httpTAG({
                    url: this.$httpTAG.adornUrl('/business/login'),
                    method: 'post',
                    data: this.ruleForm,
                    headers: {
                        'Content-Type': 'application/json',
                        'Access-Token': this.token  //将token放在请求头带到后端
                    }
                }).then(res => {
                    if (res.data.code == 0) {
                        this.$message({ // 成功
                            duration: 700, //500毫秒后关闭弹窗,
                            type: 'success',
                            message: '登录成功'
                        })

                        localStorage.removeItem("menus")
                        localStorage.removeItem("menuList")
                        localStorage.removeItem('permissionSet')
                        localStorage.removeItem('user_token')

                        localStorage.removeItem('CURR_ZT_ID');
                        localStorage.removeItem('CURR_ZT_NAME');
                        localStorage.removeItem('CURR_ZT_DATE');

                        localStorage.setItem("user_token", res.headers['authorization']);
                        this.getUserInfo();
                    } else {
                        this.$message({ // 失败
                            type: 'error',
                            message: res.data.msg
                        })
                        this.reImg();
                        this.ruleForm.code = '';
                    }
                }).finally(r => {
                })

            },
            // 获取当前管理员信息
            getUserInfo() {
                this.$httpTAG({
                    url: this.$httpTAG.adornUrl("/business/getUserMenuList"),
                    method: 'post'
                }).then(({data}) => {

                    localStorage.setItem('permissionSet', JSON.stringify(data.data.permission || '[]'))
                    localStorage.setItem("menus", JSON.stringify(data.data.menus || '[]'))
                    localStorage.setItem('menuList', JSON.stringify(data.data.menus || '[]'))

                    this.$router.push('/home') //成功跳转到首页

                })
            }
        },
        created() {
            let isLoginTimeOut = localStorage.getItem('isLoginTimeOut');
            if (isLoginTimeOut == "true") {
                localStorage.setItem("isLoginTimeOut", "false");
                this.$message({
                    message: '登录过期，请重新登录',
                    type: 'error',
                    duration: 2000,
                    showClose: true
                })
            }
            this.reImg();
            this.getDefaultLoginUser();
        }
    }
</script>

<style scoped>
    .loginbody {
        width: 20%;
        position: absolute;
        right: 150px;
        top: 206px;
    }

    .mcss {
        width: 100%;
        height: 70%;
        padding: 20px;
        background: url("../../assets/img/bg3.jpg");
        background-size: 100% 100%;
    }

    .loginbody >>> .el-input__inner, .el-button {
        border-radius: 0px;
    }

    .logincss {
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        right: 0;
        z-index: 1;
    }

    .heardtitle {
        padding-left: 5%;
        margin-top: 5%;
        font-size: 30px;
        color: white;
    }

    .loginbody >>> .el-input__inner {
        border-radius: 5px !important;
    }
</style>
